<div class="card">
    <div class="card-body">
        <div class="row pb-3 d-flex align-items-center g-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                role="button" tabindex="0" (click)="goBack()"
                style="cursor: pointer; width: 24px; flex: 0 0 auto;">
                <path d="M4 11.9998L20 11.9998" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.99996 17C8.99996 17 4.00001 13.3176 4 12C3.99999 10.6824 9 7.00001 9 7.00001" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <h5 class="mb-0 w-auto">Datos de carta porte</h5>
        </div>
        <form id="formCartaPorte" [formGroup]="cartaPorteForm">
            <div class="row">
                <h5 class="mb-0">Dirección</h5>
            </div>

            <!-- Help box -->
            <div class="row p-3">
                <div class="help-box mt-3 p-4" style="position: relative;">
                    <strong>¿Qué pasa si no encuentro la colonia o código postal?</strong>
                    <ul class="mb-2">
                        <li>Verifica que el código postal sea correcto si no se encuentra la colonia</li>
                        <li>Busca una colonia similar en la lista o cambia el código postal a la dirección más
                            cercana
                            al destino</li>
                    </ul>
                    <small>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                            fill="none">
                            <g clip-path="url(#clip0_99_4244)">
                                <path
                                    d="M18.3337 10C18.3337 5.39767 14.6027 1.66671 10.0003 1.66671C5.39795 1.66671 1.66699 5.39767 1.66699 10C1.66699 14.6024 5.39795 18.3334 10.0003 18.3334C14.6027 18.3334 18.3337 14.6024 18.3337 10Z"
                                    stroke="#019DDA" stroke-width="1.5" />
                                <path
                                    d="M10.2015 14.1667V10.0001C10.2015 9.60724 10.2015 9.41083 10.0795 9.28879C9.95742 9.16675 9.761 9.16675 9.36816 9.16675"
                                    stroke="#019DDA" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M9.993 6.66675H10.0005" stroke="#019DDA" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_99_4244">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg> &nbsp;
                        La dirección debe existir en el catálogo del SAT para que sea timbrado correctamente
                    </small>
                    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none" style="position: absolute; top: -10px; right: 15px;">
                        <path d="M47.6673 25.0609C47.6673 36.5077 37.9655 45.7888 26.0007 45.7888C24.5938 45.7906 23.191 45.6605 21.8091 45.401C20.8144 45.2142 20.317 45.1208 19.9698 45.1738C19.6226 45.2268 19.1305 45.4885 18.1465 46.0118C15.3626 47.4923 12.1165 48.0151 8.99472 47.4345C10.1813 45.975 10.9916 44.2239 11.3492 42.3467C11.5658 41.1985 11.029 40.083 10.2249 39.2664C6.57287 35.558 4.33398 30.5607 4.33398 25.0609C4.33398 13.6141 14.0358 4.33301 26.0007 4.33301C37.9655 4.33301 47.6673 13.6141 47.6673 25.0609Z" fill="#019DDA" stroke="#019DDA" stroke-width="1.5" stroke-linejoin="round"/>
                        <path d="M26 35.75H26.0195" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21.667 21.333C21.667 19.1239 23.6071 17.333 26.0003 17.333C28.3936 17.333 30.3337 19.1239 30.3337 21.333C30.3337 22.1293 30.0816 22.8713 29.6471 23.4946C28.352 25.3524 26.0003 27.1239 26.0003 29.333V30.333" stroke="white" stroke-width="3" stroke-linecap="round"/>
                    </svg>
                </div>
            </div>

            <!-- Origen Address Section -->
            <div class="mb-3 p-3 rounded border">
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label">Origen</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="origin_calle"
                                placeholder="Av. Dr. Gustavo Baz 110">
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                        <small class="text-muted mt-2 d-flex align-items-start">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                                class="flex-shrink-0">
                                <g clip-path="url(#clip0_99_6104)">
                                    <path
                                        d="M14.6663 8.00008C14.6663 4.31818 11.6816 1.33342 7.99967 1.33342C4.31778 1.33342 1.33301 4.31818 1.33301 8.00008C1.33301 11.682 4.31778 14.6667 7.99967 14.6667C11.6816 14.6667 14.6663 11.682 14.6663 8.00008Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M8.16178 11.3334V8.00004C8.16178 7.68577 8.16178 7.52864 8.06415 7.43101C7.96652 7.33337 7.80939 7.33337 7.49512 7.33337"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.99499 5.33337H8.00098" stroke="#989898" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_99_6104">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            <span class="ms-2">Esta dirección se usa como referencia. Los datos fiscales se obtienen del catalogo
                                SAT</span>
                        </small>
                    </div>
                </div>
                <div class="row">
                    <!-- Código Postal Origen -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Código postal *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="origin_codigo_postal"
                                placeholder="54030">
                            <span class="input-group-text">
                                <!-- Success icon when postal code exists and is valid -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" *ngIf="existCodeOrigen == 1">
                                    <path
                                        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                        stroke="#41AD4C" stroke-width="1.5" />
                                    <path d="M8 12.5L10.5 15L16 9" stroke="#41AD4C" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <!-- Error icon when postal code doesn't exist -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" *ngIf="existCodeOrigen == 2">
                                    <path
                                        d="M5.32171 9.68293C7.73539 5.41199 8.94222 3.27651 10.5983 2.72681C11.5093 2.4244 12.4907 2.4244 13.4017 2.72681C15.0578 3.27651 16.2646 5.41199 18.6783 9.68293C21.092 13.9539 22.2988 16.0893 21.9368 17.8293C21.7376 18.7866 21.2469 19.6549 20.535 20.3097C19.241 21.5 16.8274 21.5 12 21.5C7.17265 21.5 4.75897 21.5 3.46496 20.3097C2.75308 19.6549 2.26239 18.7866 2.06322 17.8293C1.70119 16.0893 2.90803 13.9539 5.32171 9.68293Z"
                                        stroke="#CF091C" stroke-width="1.5" />
                                    <path d="M11.992 16H12.001" stroke="#CF091C" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 13L12 9" stroke="#CF091C" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                                <!-- Loading spinner when searching -->
                                <div class="spinner-border spinner-border-sm" role="status" *ngIf="loadingColoniasOrigen">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </span>
                        </div>
                        <small class="text-muted mt-2 d-flex align-items-start">
                            <span *ngIf="existCodeOrigen == 2" class="not-exist">Código postal invalido. No encontrado en el
                                catalogo del SAT</span>
                            <span *ngIf="existCodeOrigen == 1" class="exist">Código postal valido</span>
                        </small>
                    </div>

                    <!-- País Origen -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">País *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="origin_pais"
                                placeholder="MEX">
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Estado Origen -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Estado *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="origin_estado"
                                placeholder="México">
                            <span class="input-group-text border-start-0 border-end-0 p-0" *ngIf="dataOrigin?.c_Estado">
                                <span class="badge bg-info bad">{{dataOrigin?.c_Estado}}</span>
                            </span>
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Municipio Origen -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Código de Municipio *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="origin_municipio"
                                placeholder="Tlalnepantla">
                            <span class="input-group-text border-start-0 border-end-0 p-0" *ngIf="dataOrigin?.c_Municipio">
                                <span class="badge bg-info bad">{{dataOrigin?.c_Municipio}}</span>
                            </span>
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Localidad Origen -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Código de Localidad *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="origin_localidad"
                                placeholder="14">
                            <span class="input-group-text border-start-0 border-end-0 p-0" *ngIf="dataOrigin?.c_Localidad">
                                <span class="badge bg-info bad">{{dataOrigin?.c_Localidad}}</span>
                            </span>
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Colonia Origen -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Colonia *</label>
                        <div class="select-wrapper" *ngIf="coloniasOrigen.length > 0; else coloniaOrigenInput">
                            <select class="form-select select-custom" formControlName="origin_colonia"
                                [ngClass]="registerFormControl['origin_colonia'].errors && !registerFormControl['origin_colonia'].pristine ? 'is-invalid' : ''">
                                <option value="">Seleccione una colonia</option>
                                <option *ngFor="let colonia of coloniasOrigen" [value]="colonia.c_Colonia">
                                    {{ colonia.descripcion }}
                                </option>
                            </select>

                            <!-- Badge -->
                            <span class="select-badge" *ngIf="registerFormControl['origin_colonia'].value">
                                <span class="badge bg-info bad">{{ getSelectedColoniaOrigenCode() }}</span>
                            </span>

                        </div>
                        <ng-template #coloniaOrigenInput>
                            <input type="text" class="form-control" formControlName="origin_colonia"
                                placeholder="Centro Industrial Tlalnepantla"
                                [ngClass]="registerFormControl['origin_colonia'].errors && !registerFormControl['origin_colonia'].pristine ? 'is-invalid' : ''">
                        </ng-template>
                        <div *ngIf="loadingColoniasOrigen" class="mt-1">
                            <small class="text-info">
                                <span class="spinner-border spinner-border-sm" role="status"></span>
                                Buscando colonias...
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Destination Address Section -->
            <div class="mb-3 p-3 rounded border">
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label">Destino</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="destination_calle"
                                placeholder="Av. Dr. Gustavo Baz 110">
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>

                        <small class="text-muted mt-2 d-flex align-items-start">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="flex-shrink-0">
                                <g clip-path="url(#clip0_99_6104)">
                                    <path d="M14.6663 8.00008C14.6663 4.31818 11.6816 1.33342 7.99967 1.33342C4.31778 1.33342 1.33301 4.31818 1.33301 8.00008C1.33301 11.682 4.31778 14.6667 7.99967 14.6667C11.6816 14.6667 14.6663 11.682 14.6663 8.00008Z" stroke="#989898" stroke-width="1.5"/>
                                    <path d="M8.16178 11.3334V8.00004C8.16178 7.68577 8.16178 7.52864 8.06415 7.43101C7.96652 7.33337 7.80939 7.33337 7.49512 7.33337" stroke="#989898" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M7.99499 5.33337H8.00098" stroke="#989898" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_99_6104">
                                    <rect width="16" height="16" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg> 
                            <span class="ms-2">Esta dirección se usa como referencia. Los datos fiscales se obtienen del catalogo SAT</span>
                        </small>
                    </div>
                </div>
                <div class="row">
                    <!-- Código Postal -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Código postal *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="destination_codigo_postal"
                                placeholder="54030" (change)="onPostalCodeChange($event)">
                            <span class="input-group-text">
                                <!-- Success icon when postal code exists and is valid -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" *ngIf="existCode == 1">
                                    <path d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
                                        stroke="#41AD4C" stroke-width="1.5" />
                                    <path d="M8 12.5L10.5 15L16 9" stroke="#41AD4C" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <!-- Error icon when postal code doesn't exist -->
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" *ngIf="existCode == 2">
                                    <path
                                        d="M5.32171 9.68293C7.73539 5.41199 8.94222 3.27651 10.5983 2.72681C11.5093 2.4244 12.4907 2.4244 13.4017 2.72681C15.0578 3.27651 16.2646 5.41199 18.6783 9.68293C21.092 13.9539 22.2988 16.0893 21.9368 17.8293C21.7376 18.7866 21.2469 19.6549 20.535 20.3097C19.241 21.5 16.8274 21.5 12 21.5C7.17265 21.5 4.75897 21.5 3.46496 20.3097C2.75308 19.6549 2.26239 18.7866 2.06322 17.8293C1.70119 16.0893 2.90803 13.9539 5.32171 9.68293Z"
                                        stroke="#CF091C" stroke-width="1.5" />
                                    <path d="M11.992 16H12.001" stroke="#CF091C" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 13L12 9" stroke="#CF091C" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>

                                <!-- Loading spinner when searching -->
                                <div class="spinner-border spinner-border-sm" role="status" *ngIf="loadingColonias">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </span>
                        </div>
                        <small class="text-muted mt-2 d-flex align-items-start">
                            <span *ngIf="existCode == 2" class="not-exist">Código postal invalido. No encontrado en el catalogo del SAT</span>
                            <span *ngIf="existCode == 1" class="exist">Código postal valido</span>
                        </small>
                    </div>

                    <!-- País -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">País *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="destination_pais"
                                placeholder="MEX">
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Estado -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Estado *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="destination_estado"
                                placeholder="México">
                            <span class="input-group-text border-start-0 border-end-0 p-0" *ngIf="dataDestination?.c_Estado">
                                <span class="badge bg-info bad">{{dataDestination?.c_Estado}}</span>
                            </span>
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Municipio -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Código de Municipio *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="destination_municipio"
                                placeholder="Tlalnepantla">
                            <span class="input-group-text border-start-0 border-end-0 p-0" *ngIf="dataDestination?.c_Municipio">
                                <span class="badge bg-info bad">{{dataDestination?.c_Municipio}}</span>
                            </span>
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Localidad -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Código de Localidad *</label>
                        <div class="input-group">
                            <input type="text" class="form-control" formControlName="destination_localidad"
                                placeholder="14">
                            <span class="input-group-text border-start-0 border-end-0 p-0" *ngIf="dataDestination?.c_Localidad">
                                <span class="badge bg-info bad">{{dataDestination?.c_Localidad}}</span>
                            </span>
                            <span class="input-group-text">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M4.26781 18.8447C4.49269 20.515 5.87613 21.8235 7.55966 21.9009C8.97627 21.966 10.4153 22 12 22C13.5847 22 15.0237 21.966 16.4403 21.9009C18.1239 21.8235 19.5073 20.515 19.7322 18.8447C19.879 17.7547 20 16.6376 20 15.5C20 14.3624 19.879 13.2453 19.7322 12.1553C19.5073 10.485 18.1239 9.17649 16.4403 9.09909C15.0237 9.03397 13.5847 9 12 9C10.4153 9 8.97627 9.03397 7.55966 9.09909C5.87613 9.17649 4.49269 10.485 4.26781 12.1553C4.12104 13.2453 4 14.3624 4 15.5C4 16.6376 4.12104 17.7547 4.26781 18.8447Z"
                                        stroke="#989898" stroke-width="1.5" />
                                    <path
                                        d="M7.5 9V6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5V9"
                                        stroke="#989898" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.9961 15.5H12.0051" stroke="#989898" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>

                    <!-- Colonia -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Colonia *</label>
                        <div class="select-wrapper" *ngIf="colonias.length > 0; else coloniaInput">
                            <select class="form-select select-custom" id="cpSelect" formControlName="destination_colonia"
                                [ngClass]="registerFormControl['destination_colonia'].errors && !registerFormControl['destination_colonia'].pristine ? 'is-invalid' : ''">
                                <option value="">Seleccione una colonia</option>
                                <option *ngFor="let colonia of colonias" [value]="colonia.c_Colonia">
                                    {{ colonia.descripcion }}
                                </option>
                            </select>

                            <!-- Badge -->
                            <span class="select-badge" *ngIf="registerFormControl['destination_colonia'].value">
                                <span class="badge bg-info bad">{{ getSelectedColoniaCode() }}</span>
                            </span>

                        </div>
                        <ng-template #coloniaInput>
                            <input type="text" class="form-control" formControlName="destination_colonia"
                                placeholder="Centro Industrial Tlalnepantla"
                                [ngClass]="registerFormControl['destination_colonia'].errors && !registerFormControl['destination_colonia'].pristine ? 'is-invalid' : ''">
                        </ng-template>
                        <div *ngIf="loadingColonias" class="mt-1">
                            <small class="text-info">
                                <span class="spinner-border spinner-border-sm" role="status"></span>
                                Buscando colonias...
                            </small>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row pb-3">
                <h5 class="mb-0">Transporte y distancia</h5>
            </div>
            <div class="mb-3 p-3 rounded border">
                <div class="row">
                    <div class="col">
                        <label class="form-label ">Medio de transporte*</label>
                        <select class="form-select" formControlName="transport_mean_id"
                            [ngClass]="registerFormControl['transport_mean_id'].errors && !registerFormControl['transport_mean_id'].pristine ? 'is-invalid' : ''">
                            <option value="">Seleccione una opción</option>
                            <option *ngFor="let t of transportMeans" [value]="t.id">{{ t.key }} - {{ t.name }}</option>
                        </select>
                    </div>
                    <div class="col">
                        <label class="form-label ">Total de distancia recorrida*</label>
                        <br>
                        <span>
                            {{registerFormControl['total_distance'].value}} KM
                        </span>
                    </div>
                </div>
            </div>
            <div class="row pb-3">
                <h5 class="mb-0">Detalles de la mercancia</h5>
            </div>
            <div class="mb-3 p-3 rounded border">
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label ">Valor de la mercancia*</label>
                        <input type="number" class="form-control" formControlName="cfdi_subtotal"
                            (change)="onSubtotalChange($event)"
                            [ngClass]="registerFormControl['cfdi_subtotal'].errors && !registerFormControl['cfdi_subtotal'].pristine ? 'is-invalid' : ''">
                    </div>
                    <div class="col">
                        <label class="form-label ">Peso bruto total*</label>
                        <input type="number" step="0.01" class="form-control" formControlName="gross_weight_total"
                            placeholder="1000.00"
                            [ngClass]="registerFormControl['gross_weight_total'].errors && !registerFormControl['gross_weight_total'].pristine ? 'is-invalid' : ''">
                    </div>
                    <div class="col">
                        <label class="form-label ">Unidad de peso*</label>
                        <select class="form-select" formControlName="weight_unit_id" placeholder="Seleccione una opción"
                            [ngClass]="registerFormControl['weight_unit_id'].errors && !registerFormControl['weight_unit_id'].pristine ? 'is-invalid' : ''">
                            <option value="">Seleccione una opción</option>
                            <option *ngFor="let u of weightUnits" [value]="u.id">{{ u.key }} - {{ u.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label ">Dimensiones*</label>
                        <input type="text" class="form-control" formControlName="dimensions"
                            placeholder="Ejemplo: 59/40/35"
                            [ngClass]="registerFormControl['dimensions'].errors && !registerFormControl['dimensions'].pristine ? 'is-invalid' : ''">
                    </div>
                    <div class="col">
                        <label class="form-label ">Unidad de medida*</label>
                        <select class="form-select" formControlName="measurement_unit_id"
                            [ngClass]="registerFormControl['measurement_unit_id'].errors && !registerFormControl['measurement_unit_id'].pristine ? 'is-invalid' : ''">
                            <option value="">Seleccione una opción</option>
                            <option *ngFor="let m of measurementUnits" [value]="m.id">{{ m.key }} - {{ m.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col">
                        <label class="form-label ">Número total de mercancías*</label>
                        <input type="number" class="form-control" formControlName="total_goods"
                            [ngClass]="registerFormControl['total_goods'].errors && !registerFormControl['total_goods'].pristine ? 'is-invalid' : ''">
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label ">Logística Inversa*</label>
                        <select class="form-select" formControlName="logistics_type_id"
                            [ngClass]="registerFormControl['logistics_type_id'].errors && !registerFormControl['logistics_type_id'].pristine ? 'is-invalid' : ''">
                            <option value="">Seleccione una opción</option>
                            <option *ngFor="let t of logisticsTypes" [value]="t.id">{{ t.name }}</option>
                        </select>
                    </div>
                    <div class="col">
                        <label class="form-label ">¿La mercancía es peligrosa?*</label>
                        <select class="form-select" formControlName="hazardous_material_option_id"
                            [ngClass]="registerFormControl['hazardous_material_option_id'].errors && !registerFormControl['hazardous_material_option_id'].pristine ? 'is-invalid' : ''">
                            <option value="">Seleccione una opción</option>
                            <option *ngFor="let h of hazardousMaterialOptions" [value]="h.id">{{ h.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col"></div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label ">Tipo de mercancía transportada*</label>
                        <select class="form-select" formControlName="unit_key_id"
                            [ngClass]="registerFormControl['unit_key_id'].errors && !registerFormControl['unit_key_id'].pristine ? 'is-invalid' : ''">
                            <option value="">Seleccione una opción</option>
                            <option *ngFor="let u of unitKeys" [value]="u.id">{{ u.name }}</option>
                        </select>
                    </div>
                    
                    
                </div>
            </div>
            <div class="row pb-3">
                <h5 class="mb-0">Detalles e identificación del autotransporte</h5>
            </div>
            <div class="mb-3 p-3 rounded border">
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label ">Permiso de SCT</label>
                        <br>
                        <span>{{ selectedService?.unit?.permit_type?.key }} - {{
                            selectedService?.unit?.permit_type?.description}}</span>
                    </div>
                    <div class="col">
                        <label class="form-label ">Número de permiso SCT</label>
                        <br>
                        <span>{{selectedService?.unit?.permit_number}}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-6">
                        <label class="form-label ">Configuración vehicular</label>
                        <br>
                        <span>{{ selectedService?.unit?.vehicle_configuration?.code }} - {{
                            selectedService?.unit?.vehicle_configuration?.description}}</span>
                    </div>
                    <div class="col">
                        <label class="form-label ">Placa vehiculo motor</label>
                        <br>
                        <span>{{selectedService?.unit?.plates}}</span>
                    </div>
                    <div class="col">
                        <label class="form-label ">Año del modelo</label>
                        <br>
                        <span>{{selectedService?.unit?.unit_year}}</span>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <label class="form-label ">Peso bruto del vehiculo</label>
                        <br>
                        <span>{{selectedService?.unit?.peso_bruto | number:'1.0-0'}}KG</span>
                    </div>
                </div>
            </div>

            <div class="row pb-3">
                <h5 class="mb-0">Seguros</h5>
            </div>
            <div class="mb-3 p-3 rounded border">
                <div class="row">
                    <div class="col">
                        <label class="form-label ">Aseguradora de responsabilidad civil</label>
                        <br>
                        <span>{{ selectedService?.unit?.liability_insurer?.name ?
                            selectedService?.unit?.liability_insurer?.name : 'N/A' }}</span>
                    </div>
                    <div class="col">
                        <label class="form-label ">Número de póliza de seguro por responsabilidad civil </label>
                        <br>
                        <span>{{selectedService?.unit?.liability_policy_number ?
                            selectedService?.unit?.liability_policy_number : 'N/A'}}</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label class="form-label ">Aseguradora de daños al medio ambiente</label>
                        <br>
                        <span>{{ selectedService?.unit?.environmental_insurer?.name ?
                            selectedService?.unit?.environmental_insurer?.name : 'N/A'}}</span>
                    </div>
                    <div class="col">
                        <label class="form-label ">Número de póliza de seguro por daños al medio ambiente</label>
                        <br>
                        <span>{{selectedService?.unit?.environmental_policy_number ?
                            selectedService?.unit?.environmental_policy_number : 'N/A'}}</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label class="form-label ">Aseguradora de la carga transportada (Opcional)</label>
                        <select class="form-select" formControlName="cargo_insurer_id"
                            [ngClass]="registerFormControl['cargo_insurer_id'].errors && !registerFormControl['cargo_insurer_id'].pristine ? 'is-invalid' : ''">
                            <option value="">Seleccione una opción</option>
                            <option *ngFor="let a of cargoInsurers" [value]="a.id">{{ a.name }}</option>
                        </select>
                    </div>
                    <div class="col">
                        <label class="form-label ">Número de póliza (Opcional)</label>
                        <input type="text" class="form-control" formControlName="cargo_insurance_policy_number"
                            placeholder="Ejemplo: 0X2XTXZ0X5X0X3X2X1X0"
                            [ngClass]="registerFormControl['cargo_insurance_policy_number'].errors && !registerFormControl['cargo_insurance_policy_number'].pristine ? 'is-invalid' : ''">
                    </div>
                    <div class="col">
                        <label class="form-label ">Valor de la prima del seguro (Opcional)</label>
                        <input type="number" step="0.01" class="form-control" formControlName="insurance_premium_value"
                            placeholder="Ejemplo: 1,200.00"
                            [ngClass]="registerFormControl['insurance_premium_value'].errors && !registerFormControl['insurance_premium_value'].pristine ? 'is-invalid' : ''">
                    </div>
                </div>
            </div>
            <!-- <div class="row pb-3">
                <h5 class="mb-0">Remolque</h5>
            </div>
            <div class="mb-3 p-3 rounded border">
                <div class="row">
                    <div class="col">
                        <label class="form-label ">Remolque</label>
                        <br>
                        <span>{{ (selectedService?.requires_trailer === true || selectedService?.requires_trailer === 1) ? (selectedTrailer?.trailer || 'N/A') : 'N/A' }}</span>
                    </div>
                    <div class="col">
                        <label class="form-label ">Placa</label>
                        <br>
                        <span>{{ (selectedService?.requires_trailer === true || selectedService?.requires_trailer === 1) ? (selectedTrailer?.plate || 'N/A') : 'N/A' }}</span>
                    </div>
                </div>
            </div> -->
            <div class="row pb-3">
                <h5 class="mb-0">Impuestos CFDI</h5>
            </div>
            <div class="mb-3 p-3">
                <div class="row mt-3">
                    <div class="col"></div>
                    <div class="col d-flex align-items-end">
                        <div class="alert alert-outline-info w-100 mb-0 p-3 border rounded">
                            <div class="d-flex justify-content-between">
                                <span>Subtotal</span>
                                <strong>{{ cartaPorteForm.get('cfdi_subtotal')?.value || '0.00' }}</strong>
                            </div>
                            <div class="d-flex justify-content-between">
                                <span>Impuestos ({{ taxRatePercentDisplay }}%)</span>
                                <strong>{{ cartaPorteForm.get('cfdi_total_impuestos_trasladados')?.value || '0.00'
                                    }}</strong>
                            </div>
                            <div class="d-flex justify-content-between border-top pt-2 mt-2">
                                <span>Total</span>
                                <strong>{{ cartaPorteForm.get('cfdi_total')?.value || '0.00' }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col text-center">
                    <button type="button" class="btn btn-outline-primary m-2" (click)="updateCartaPorte()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M8 22V19C8 17.1144 8 16.1716 8.58579 15.5858C9.17157 15 10.1144 15 12 15C13.8856 15 14.8284 15 15.4142 15.5858C16 16.1716 16 17.1144 16 19V22" stroke="#019DDA" stroke-width="1.5" stroke-linejoin="round"/>
                            <path d="M10 7H14" stroke="#019DDA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M3 11.8584C3 7.28199 3 4.99376 4.38674 3.54394C4.43797 3.49038 4.49038 3.43797 4.54394 3.38674C5.99376 2 8.28199 2 12.8584 2C13.943 2 14.4655 2.00376 14.9628 2.18936C15.4417 2.3681 15.8429 2.70239 16.6452 3.37099L18.8411 5.20092C19.9027 6.08561 20.4335 6.52795 20.7168 7.13266C21 7.73737 21 8.42833 21 9.81025V13C21 16.7497 21 18.6246 20.0451 19.9389C19.7367 20.3634 19.3634 20.7367 18.9389 21.0451C17.6246 22 15.7497 22 12 22C8.25027 22 6.3754 22 5.06107 21.0451C4.6366 20.7367 4.26331 20.3634 3.95491 19.9389C3 18.6246 3 16.7497 3 13V11.8584Z" stroke="#019DDA" stroke-width="1.5"/>
                        </svg> Guardar
                    </button>
                    <button type="button" class="btn btn-primary m-2" (click)="saveAndStampCfdi()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M9.99128 15C9.99128 14.0015 9.90819 11.6348 8.15796 8.26951C7.38157 6.77671 7.39203 5.2142 7.6806 3.98372C7.77486 3.58177 8.01266 3.37651 8.33553 3.15508C8.70845 2.89932 8.89491 2.77143 9.08803 2.66275C9.70688 2.31447 10.393 2.10186 11.1006 2.03909C11.6881 1.98697 12.3119 1.98697 12.8994 2.03909C13.607 2.10186 14.2931 2.31447 14.912 2.66275C15.1051 2.77143 15.2916 2.89932 15.6645 3.15508C15.9873 3.37651 16.2251 3.58177 16.3194 3.98372C16.608 5.2142 16.6184 6.77671 15.842 8.26951C14.0918 11.6348 14.0087 14.0015 14.0087 15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.0883 17.7351C7.52832 16.4151 7.74832 15.755 8.2721 15.3775C8.79587 15 9.49159 15 10.883 15H13.117C14.5084 15 15.2041 15 15.7279 15.3775C16.2517 15.755 16.4717 16.4151 16.9117 17.7351L17 18H7L7.0883 17.7351Z" stroke="white" stroke-width="1.5"/>
                            <path d="M4.25262 20.1823C4.46592 19.645 4.57257 19.3764 4.72208 19.1551C5.10369 18.5902 5.70937 18.1937 6.40325 18.0545C6.67511 18 6.97885 18 7.58633 18L16.4137 18C17.0212 18 17.3249 18 17.5967 18.0545C18.2906 18.1937 18.8963 18.5902 19.2779 19.1551C19.4274 19.3764 19.5341 19.645 19.7474 20.1823C19.9125 20.5983 19.9951 20.8063 19.9996 20.9744C20.0115 21.4099 19.7234 21.8025 19.2876 21.945C19.1194 22 18.8842 22 18.4139 22H5.5861C5.11579 22 4.88064 22 4.71244 21.945C4.27658 21.8025 3.98853 21.4099 4.00035 20.9744C4.00491 20.8063 4.08748 20.5983 4.25262 20.1823Z" stroke="white" stroke-width="1.5"/>
                        </svg>
                        Timbrar</button>
                    
                </div>
            </div>
            <!-- <div class="row mt-4">
                <div class="col text-end">
                    <button type="button" class="btn btn-outline-primary me-2" (click)="saveAndStampCfdi()">Guardar
                        &amp; Timbrar</button>
                    <button type="button" class="btn btn-info" (click)="updateCartaPorte()">Actualizar</button>
                </div>
            </div> -->


        </form>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
